import { useQuery } from "@tanstack/react-query";
import { permissionService } from "../api/services/permissionService";
import { Permission } from "../schemas/permissionSchema";

/**
 * Every permission in the system, unpaginated.
 *
 * For the role form's module x action matrix, which has to show the complete
 * set: a permission missing from the matrix is a permission no role can be
 * granted. Use `usePermissions` for the paginated Permissions list page.
 */
export const useAllPermissions = () => {
  const { data, isLoading, error, refetch } = useQuery<Permission[], Error>({
    queryKey: ["permissions", "all"],
    queryFn: () => permissionService.getEvery(),
  });

  return {
    permissions: data ?? [],
    isLoading,
    error,
    refetchPermissions: refetch,
  };
};
